// External libraries
import gql from 'graphql-tag';

export const ONBOARD_GUEST_MUTATION = gql`
  mutation OnboardGuestMutation(
    $bank: BankAccountInput
    $billingAddress: AddressInput
    $card: CardInput
    $country: CountryCodes
    $currencyConversionType: CheckoutCurrencyConversionType
    $dateOfBirth: DateOfBirth
    $email: String
    $firstName: String!
    $lastName: String!
    $phone: PhoneInput
    $shareAddressWithDonatee: Boolean
    $shippingAddress: AddressInput
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
    $token: String!
  ) {
    onboardAccount: onboardGuest(
      bank: $bank
      billingAddress: $billingAddress
      card: $card
      country: $country
      currencyConversionType: $currencyConversionType
      dateOfBirth: $dateOfBirth
      email: $email
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      shareAddressWithDonatee: $shareAddressWithDonatee
      shippingAddress: $shippingAddress
      token: $token
    ) {
      buyer {
        auth {
          accessToken
        }
        userId
      }

      flags {
        is3DSecureRequired
      }

      paymentContingencies {
        threeDomainSecure(experiences: $supportedThreeDsExperiences) {
          status
          redirectUrl {
            href
          }
          method
          parameter
          experience
          requestParams {
            key
            value
          }
        }
        threeDSContingencyData {
          name
          causeName
          resolution {
            type
            resolutionName
            paymentCard {
              id
              type
              number
              bankIdentificationNumber
            }
            contingencyContext {
              deviceDataCollectionUrl {
                href
              }
              jwtSpecification {
                jwtDuration
                jwtIssuer
                jwtOrgUnitId
                type
              }
              reason
              referenceId
              source
            }
          }
        }
      }
    }
  }
`;
